import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from '../landing/App.vue';
import messages from '../landing/en.json';
import '../landing/tailwind.css';

createApp(App)
  .use(createI18n({ legacy: false, locale: 'fa', messages: { fa: messages } }))
  .mount('#landing');
